import { processSteps, trustStats } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

export default function Method() {
  return (
    <section id="method" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          index="04"
          kicker="梳理方法"
          title="我们怎样保证经过不漏"
          desc="做「事件梳理」最怕被带节奏。本站用一套可复核的流程来确保每个节点都有出处、每段前因后果都对得上。"
        />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.2fr]">
          {/* left narrative */}
          <div className="flex flex-col justify-center">
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              你看到的每一段完整时间线，都不是编辑拍脑袋写出来的，而是从一条条<b className="text-foreground-950">可回溯节点</b>
              出发，用多平台信源交叉拼接而成。碰到互相打架的说法，我们会把它们<b className="text-foreground-950">并列呈现并标注「存疑」</b>，
              绝不替你站队下结论。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {["信源可回溯", "口径不偏倚", "反转必补录", "30 天复核"].map((k) => (
                <div
                  key={k}
                  className="flex items-center gap-2.5 rounded-lg border border-background-200 bg-background-100 px-4 py-3"
                >
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  <span className="text-sm font-semibold text-foreground-800">{k}</span>
                </div>
              ))}
            </div>
            <a
              href="#faq"
              className="mt-6 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer"
            >
              查看完整编辑准则
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* right steps */}
          <div className="space-y-4">
            {processSteps.map((s) => (
              <div
                key={s.step}
                className="group flex gap-5 rounded-xl border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-primary-300"
              >
                <span className="font-heading text-4xl text-accent-500 transition-colors group-hover:text-accent-600">
                  {s.step}
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* trust stats band */}
        <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 sm:grid-cols-4">
          {trustStats.map((t) => (
            <div
              key={t.label}
              className="flex flex-col items-center bg-background-100 px-4 py-7 text-center"
            >
              <span className="font-heading text-3xl text-accent-500 md:text-4xl">{t.value}</span>
              <span className="mt-2 text-xs text-foreground-600 md:text-sm">{t.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}